// ✅ src/components/Signup.js
import React, { useState } from 'react';
import { auth, db } from '../firebase';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';

function Signup() {
  const [userId, setUserId] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [birthdate, setBirthdate] = useState('');
  const [userType, setUserType] = useState('student');
  const [schoolLevel, setSchoolLevel] = useState('elementary');
  const [grade, setGrade] = useState('1');

  const handleSignup = async () => {
    try {
      const email = `${userId}@placeholder.com`; // 이메일 대신 아이디 기반 가짜 이메일 생성
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      await setDoc(doc(db, "users", user.uid), {
        userId,
        name,
        birthdate,
        role: userType,
        schoolLevel,
        grade,
        approved: false
      });

      alert("회원가입이 완료되었습니다. 관리자의 승인을 기다려주세요.");
    } catch (error) {
      alert("에러: " + error.message);
    }
  };

  const renderGradeOptions = () => {
    const count = schoolLevel === 'elementary' ? 6 : 3;
    return Array.from({ length: count }, (_, i) => (
      <option key={i + 1} value={String(i + 1)}>{i + 1}학년</option>
    ));
  };

  return (
    <div>
      <h2>회원가입</h2>
      <input type="text" placeholder="아이디" value={userId} onChange={(e) => setUserId(e.target.value)} /><br />
      <input type="password" placeholder="비밀번호" value={password} onChange={(e) => setPassword(e.target.value)} /><br />
      <input type="text" placeholder="이름" value={name} onChange={(e) => setName(e.target.value)} /><br />
      <input type="date" value={birthdate} onChange={(e) => setBirthdate(e.target.value)} /><br />

      <select value={userType} onChange={(e) => setUserType(e.target.value)}>
        <option value="student">학생</option>
        <option value="instructor">강사</option>
        <option value="admin">관리자</option>
      </select><br />

      {userType === 'student' && (
        <>
          <select value={schoolLevel} onChange={(e) => setSchoolLevel(e.target.value)}>
            <option value="elementary">초등학생</option>
            <option value="middle">중학생</option>
            <option value="high">고등학생</option>
          </select><br />
          <select value={grade} onChange={(e) => setGrade(e.target.value)}>
            {renderGradeOptions()}
          </select><br />
        </>
      )}

      <button onClick={handleSignup}>회원가입</button>
    </div>
  );
}

export default Signup;
